import React, { useEffect, useRef, useState } from "react";
import "../styles/contactFloater.css";
import useOnScreen from "./useOnScreen";
import { Parallax } from "react-scroll-parallax";

function ContactFloater(props) {
  const [onScreenChange, isVisible] = useOnScreen({
    root: null,
    rootMargine: "0px",
    threshold: 0.2,
    undoOnHidden: true,
  });
  const [attributesOnScreen, setAtt] = useState(false);

  function toggleAtt() {
    setAtt(!attributesOnScreen);
  }

  return (
    <>
      <div className="">
        <div
          className={isVisible ? "floatGone float floatTop" : "float floatTop"}
        >
          <img className="contactIcon" src={require("../assets/contact.png")} />
          <h5 className="firstH4">Contact Me!</h5>
          <h4
            onClick={() =>
              window.open("https://www.linkedin.com/in/ramin-kahidi-bb84b921b/")
            }
          >
            <div className="innerContact">LinkedIn</div>
          </h4>
          <h4 onClick={() => window.open("https://github.com/RaminKahidi")}>
            <div className="innerContact">Github</div>
          </h4>
          {/* <h4 onClick={() => window.open("mailto:hello@raminkahidi.com")}> */}
          <h4 onClick={() => window.open("mailto:raminkah@mit.edu")}>
            <div className="innerContact">Email</div>
          </h4>
        </div>
        {/* </Parallax> */}
      </div>
      <div id="contact">
        <div ref={onScreenChange} className="detectBottom"></div>
      </div>
    </>
  );
}

export default ContactFloater;
